export default __webpack_public_path__ + "static/media/discourse_logo_white.0d467177.svg";